import { apiSlice } from '../../api/slice'

export const formQuestionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFormByTaskIdAndFormMissionId: builder.query({
      query: ({ taskId, formMissionId }) => ({
        url: `/forms/${taskId}/${formMissionId}`,
      }),
    }),
    getUserFormSubmissionByTaskId: builder.query({
      query: ({ taskId }) => ({
        url: `/forms/${taskId}/submission`,
      }),
    }),
  }),
})

export const {
  useGetFormByTaskIdAndFormMissionIdQuery,
  useLazyGetFormByTaskIdAndFormMissionIdQuery,
  useGetUserFormSubmissionByTaskIdQuery,
  useLazyGetUserFormSubmissionByTaskIdQuery,
} = formQuestionApiSlice
